import { axios } from '../../services/axios';

export default async function getCompanyServicesWithSRT(companyID) {
    return await axios.get(`/services/company/${companyID}`);
}
